import { useChatMessages } from '@ai-sdk-tools/store';
import { useMemo } from 'react';

import { useAttachments } from './attachments-provider';
import type { UIMessageWithMetadata } from '../../../../lib/types';

/**
 * Component that displays a warning when files are attached.
 * Should be rendered below the chat input toolbar.
 */
export function WebSearchWarning() {
  const { attachments } = useAttachments();
  const messages = useChatMessages<UIMessageWithMetadata>();

  const hasAnyAttachments = useMemo(() => {
    return attachments.length > 0 || messages.some((msg) => msg.metadata?.files && msg.metadata.files.length > 0);
  }, [attachments, messages]);

  if (!hasAnyAttachments) {
    return null;
  }

  // Warning appears below the toolbar
  return (
    <div className="bg-steel-100 rounded-b-lg px-3 py-3">
      <p className="text-steel-400 text-center text-sm">Web search is disabled when a file is uploaded</p>
    </div>
  );
}
